export default __webpack_public_path__ + "static/media/medical-report.192e1f36.svg";